import PropTypes from "prop-types";
import Tooltip from "../Tooltip/Tooltip";
import { GrCircleQuestion } from "react-icons/gr";
const HeaderWithTooltip = ({ children, tooltipText }) => {
  return (
    <div className="d-flex align-items-center">
      {children}
      <Tooltip position="center" text={tooltipText}>
        <GrCircleQuestion
          className="table__date__icon ms-1" size={19}
        />
      </Tooltip>
    </div>
  );
};

HeaderWithTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipText: PropTypes.string.isRequired,
};

export default HeaderWithTooltip;
